import type { Consignee } from 'graphql-models';
import { randomId, type Factory } from 'walden-fast/types/mocks';

const MOCK_CONSIGNEE: Consignee = {
  id: '1',
  city: 'stad',
  country: 'land',
  zip: 'code',
  address: 'straat',
  name: 'naam',
};

export const consigneeFactory: Factory<Consignee> = (overrides) => ({
  ...MOCK_CONSIGNEE,
  id: randomId(),
  ...overrides,
});
